export const sectionRequiresDashboard = section => section !== 'imports';

export const commercialFilterPreset = (section, hash = '') => {
  const query = String(hash).split('?')[1] || '';
  const params = new URLSearchParams(query);
  if (section === 'renewals' && params.get('view') === 'overdue') return 'OVERDUE';
  if (section === 'renewals' && params.get('view') === 'upcoming') return 'UPCOMING';
  if (section === 'customers' && params.get('signal') === 'negative') return 'NEGATIVE';
  return 'ALL';
};

export const buildAgreementRows = (renewals = [], commitments = []) => {
  const scheduled = renewals.map(row => ({ ...row, kind: 'RENEWAL', rowType: 'RENEWAL_SCHEDULE' }));
  const linkedCommitmentIds = new Set(scheduled.map(row => row.commercialCommitmentId).filter(Boolean));
  const standalone = commitments.filter(commitment => !linkedCommitmentIds.has(commitment.id)).map(commitment => ({
    id: `commitment-${commitment.id}`,
    commercialCommitmentId: commitment.id,
    customerId: commitment.customerId,
    name: commitment.customerName,
    renewalDate: commitment.recognitionDate,
    daysUntilRenewal: null,
    arrAtRisk: Number(commitment.totalAmountMinor || 0) / 100,
    kind: commitment.kind,
    status: commitment.status,
    rowType: 'COMMITMENT',
  }));
  return [...scheduled, ...standalone];
};

export const renewalStatusIsActionable = status => !['RENEWED', 'CHURNED', 'CANCELLED'].includes(status);

export const closedRenewalRowState = row => {
  if (row.rowType !== 'RENEWAL_SCHEDULE' || renewalStatusIsActionable(row.status)) return null;
  const status = String(row.status || 'closed').replace(/_/g, ' ').toLowerCase();
  return {
    lifecycle: { label: 'Closed', detail: status.charAt(0).toUpperCase() + status.slice(1) },
    paymentLabel: 'No payment action',
    historyOnly: true,
  };
};

export const customerMatchesSignal = (row, filter) => (
  filter !== 'NEGATIVE' || Boolean(row.negativeSignal)
);

export const renewalIsActionable = row => (
  row.rowType === 'RENEWAL_SCHEDULE'
  && renewalStatusIsActionable(row.status)
);

export const agreementMatchesQueue = (row, queue) => {
  if (queue === 'ALL') return true;
  if (!renewalIsActionable(row)) return false;
  if (queue === 'OVERDUE') return row.daysUntilRenewal < 0;
  if (queue === 'URGENT') return row.daysUntilRenewal >= 0 && row.daysUntilRenewal <= 30;
  if (queue === 'UPCOMING') return row.daysUntilRenewal >= 0 && row.daysUntilRenewal <= 90;
  return true;
};

export const nextCommercialSort = (current, key) => ({
  key,
  direction: current.key === key && current.direction === 'asc' ? 'desc' : 'asc',
});

export const sortCommercialRows = (rows, sort, valueForRow = (row, key) => row[key]) => {
  if (!sort?.key) return rows;
  const direction = sort.direction === 'desc' ? -1 : 1;
  return rows.map((row, index) => ({ row, index })).sort((left, right) => {
    const leftValue = valueForRow(left.row, sort.key);
    const rightValue = valueForRow(right.row, sort.key);
    const leftMissing = leftValue === null || leftValue === undefined || leftValue === '';
    const rightMissing = rightValue === null || rightValue === undefined || rightValue === '';
    if (leftMissing !== rightMissing) return leftMissing ? 1 : -1;
    if (leftMissing) return left.index - right.index;
    const compared = typeof leftValue === 'number' && typeof rightValue === 'number'
      ? leftValue - rightValue
      : String(leftValue).localeCompare(String(rightValue), undefined, { numeric: true, sensitivity: 'base' });
    return compared ? compared * direction : left.index - right.index;
  }).map(item => item.row);
};
